import { FC } from "react";
import CorporateScreenshot from "../assets/corporate-application-image.png";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper.tsx";

const ThankYouScreenCorporate: FC<ThankYouScreenProps> = (props) => (
  <ThankYouScreenWrapper {...props} title="Log in to the platform" disableOnMobile>
    <div>
      <ol className="list-decimal list-inside space-y-4 mb-6">
        <li className="text-base leading-6 text-content-secondary">
          Log in to the desktop platform
        </li>
        <li className="text-base leading-6 text-content-secondary">
          Click &apos;Apply for a corporate account&apos; in the customer hub sidebar
        </li>
        <li className="text-base leading-6 text-content-secondary">
          Complete application
        </li>
      </ol>

      <div className="w-full rounded-lg overflow-hidden border border-surface-separator">
        <img src={CorporateScreenshot} alt="Platform screenshot showing Apply for a corporate account link" className="w-full h-auto" />
      </div>
    </div>
  </ThankYouScreenWrapper>
);

export default ThankYouScreenCorporate;
